const sidebarConfig = [
  {
    title: 'Overview',
    path: '/doctor/app',
    icon: 'eva:grid-fill',
  },
  {
    title: 'Schedule',
    path: '/doctor/calendar',
    icon: 'eva:calendar-outline',
  },
  {
    title: 'Appointments',
    path: '/doctor/appointments',
    icon: 'eva:calendar-fill',
  },
  {
    title: 'Patients',
    path: '/doctor/patients',
    icon: 'eva:people-fill',
  },
  {
    title: 'Records',
    path: '/doctor/records',
    icon: 'eva:folder-fill',
  },
  {
    title: 'Scanner',
    path: '/doctor/scanner',
    icon: 'eva:maximize-fill',
  },
  {
    title: 'Blogs',
    path: '/doctor/blogs',
    icon: 'eva:edit-2-fill',
  },
  {
    title: 'Profile',
    path: '/doctor/profile',
    icon: 'eva:person-fill',
  },
  {
    title: 'Settings',
    path: '/doctor/settings',
    icon: 'eva:settings-2-fill',
  },
];

export default sidebarConfig;